import {Component, Prop, Vue} from "vue-property-decorator";
import {Getter} from "vuex-class";
import {downloadStatFiltered, getStats} from "~/modules/stats/service";
import {formatDate} from "~/lib/helpers/formatters";
import {Loader} from "~/components/loader";
import {DataTable} from "~/components/data-table";
import {PaginationComponent} from "~/components/pagination";
import {DateTimePicker} from "~/components/forms/datetime-picker";
import {Columns} from "~/components/grid/columns";
import {Column} from "~/components/grid/column";
import {saveAs} from "file-saver";

@Component
export class StatsAuth extends Vue {

  @Prop({required: true}) clientUUID: string;
  @Getter currentUser;

  private isLoading = false

  private data = [];
  private total = 0;
  private pagination = {limit: 30, offset: 0};
  private filters = {
    email: null,
    startDate: null,
    endDate: null,
    type: 'authentication',
  };

  get headers() {
    return [
      {
        key: 'createdAt',
        value: stat => stat.created_at ? formatDate(stat.created_at) : "-",
        label: "Date",
        className: "is-narrow"
      },
      {
        key: 'user',
        value: stat => stat.user || "-",
        label: "Utilisateur"
      },
      {
        key: 'role',
        value: stat => stat.role || "-",
        label: "Role de l'utilisateur"
      },
    ];
  }

  async created() {
    await this.loadStats();
  }

  async loadStats() {
    this.isLoading = true;

    const {total, stats} = await getStats(this.currentUser.client, {
      pagination: this.pagination,
      ...this.filters,
    });

    this.total = total;
    this.data = stats;

    this.isLoading = false;
  }

  private isExporting = false;

  async export() {
    this.isExporting = true;
    try {
      const data = await downloadStatFiltered(this.currentUser.client, {
        pagination: this.pagination,
        ...this.filters,
      });
      const file = new File([data], "report.csv", {type: "text/csv;charset=utf-8"});
      saveAs(file);
    } catch (err) {
      this.$notify.error("Téléchargement du fichier impossible. Veuillez contacter le support");
      console.error(err);
    }
    this.isExporting = false;
  }

  async paginate(pagination) {
    this.pagination = pagination;
    await this.loadStats();
  }

  async setFilters() {
    this.pagination.offset = 0;
    await this.loadStats();
  }

  async resetFilters() {
    this.filters = {
      email: null,
      startDate: null,
      endDate: null,
      type: 'authentication',
    };
    this.pagination.offset = 0;
    await this.loadStats();
  }


  render() {

    if (this.isLoading) {
      return <Loader/>;
    }

    return (
      <div class="stats">
        <Columns>
          <Column>
            <label class="label is-small">Date de debut</label>
            <DateTimePicker showTime={false} v-model={this.filters.startDate}/>
          </Column>
          <Column>
            <label class="label is-small">Date de fin</label>
            <DateTimePicker showTime={false} v-model={this.filters.endDate}/>
          </Column>
          <Column>
            <label class="label is-small">Email</label>
            <input class="input is-small" type="email" v-model={this.filters.email}/>
          </Column>
        </Columns>
        <Columns>
          <Column>
            <div class="buttons" style={{marginTop: '32px'}}>
              <button class="button is-small" onClick={this.resetFilters}>Annuler les filtres</button>
              <button class="button is-small is-primary" onClick={this.setFilters}>Filtrer</button>
              <button class={`button is-small is-primary ${this.isExporting ? 'is-loading': ''}`} onClick={this.export}>Exporter</button>
            </div>
          </Column>
          <Column/>
        </Columns>
        <DataTable headers={this.headers} tableData={this.data}/>
        <PaginationComponent class="m-t-20" onChange={this.paginate} value={this.pagination} total={this.total}/>
      </div>
    );
  }
}


// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-02422510/stats-auth.tsx" });